export default {
  label: 'Canais',
  placeholder: 'Todos',
};
